import styled, { css } from 'styled-components';

export const OvernightFlightsMessageContainer = styled.div`
  background-color: #ece9f1;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  width: 100%;
  margin-bottom: 8px;
`;

export const OvernightFlightsMessageImage = styled.img`
  width: 60px;
  height: 60px;
  margin-right: 16px;
`;

export const OvernightFlightsMessageText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

const optionsSideBySide = css`
  .container-controls {
    .container-field.radio {
      padding: 0;
      width: 100%;
      justify-content: space-between;
      flex-direction: row;
      display: flex;

      > div {
        width: 50%;
      }
    }
  }
`;

const reverseLabel = css`
  .container-controls {
    .container-field.radio {
      > div > label {
        width: 100%;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
      }
    }
  }
`;

const optionsOnMultipleLines = css`
  .container-controls {
    > div {
      flex-wrap: wrap;
    }
    .container-field.radio {
      > div {
        width: 100%;
      }
    }
  }
`;

export const overnightFlightsContainerStyles = css`
  #OvernightFlightsContainer {
    .container-controls {
      > div {
        width: 100%;
      }
    }

    @media (min-width: 768px) {
      ${optionsSideBySide};
    }

    @media (max-width: 767px) {
      ${optionsOnMultipleLines};
      ${reverseLabel};
    }

    .list-container & {
      ${optionsOnMultipleLines};
    }
  }
`;

export const FacilitiesContainerStyles = css`
  &.FacilitiesContainer,
  #FacilitiesContainer {
    .container-field {
      > label {
        text-transform: uppercase;
        font-size: 12px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0.01em;
        display: block;

        margin-top: 16px;
        margin-bottom: 4px;
      }
    }
  }
`;
